// extracted by css-extract-rspack-plugin
export default {"container":"index__container___vrCWc"};